module.exports = __webpack_public_path__ + "img/shoppable-flow.1a469ab3.png";